<template lang="html">
  <div class="cookies-alert" v-show="!cookiesAccepted">
    <div class="center-wrapper">
      <div>
        <b>medstream.online</b> использует файлы cookie для персонализации и оптимизации контента.
        <br />
        Продолжая просмотр сайта, вы разрешаете их использование. <a href="/cookies/" target="_blank">Подробнее о файлах cookie.</a>
      </div>
      <div class="cookies-alert__close" @click.prevent="setAcceptCookies()">Закрыть</div>
    </div>
  </div>
</template>
<script>
    import {mapGetters} from "vuex";

    export default {
      name: 'CookiesAlert',
      components: {
      },
      data: () => ({
      }),
      computed: {
        ...mapGetters({
          cookiesAccepted: 'auth/cookiesAccepted',
        }),
      },
      methods: {
        setAcceptCookies: function () {
          this.$store.dispatch('auth/acceptCookies');
        },
      },
    };
</script>

